export default __webpack_public_path__ + "static/media/bold-font.bc6447ef.ttf";